<script lang="ts">
    import type * as t from "./types";

    import { onMount } from "svelte";
    export let step: t.IntroStep;
    export let host: HTMLElement;
    const { title, subtitle, footer, ctaButton } = step;

    let button: HTMLButtonElement;
    let isTouching = false;
    let hasTouch = "ontouchstart" in window;

    function handleClickCtaButton() {
        host.dispatchEvent(new CustomEvent("cta-click"));
    }

    onMount(() => {
        if (!hasTouch) {
            return;
        }

        button.addEventListener("touchstart", () => {
            isTouching = true;
        });

        button.addEventListener("touchend", () => {
            isTouching = false;
        });
    });
</script>

<section class="flex flex-col items-center gap-5 px-6">
    <div class="cta-text text-center">
        <div class="title block text-2xl font-bold uppercase sm:text-3xl">
            {title}
        </div>
        <div class="subtitle mt-2 uppercase">
            {@html subtitle}
        </div>
    </div>
    <button
        bind:this={button}
        class={"cta-button rounded-full px-6 py-3 font-bold uppercase transition-transform"}
        style="
            --button-bg-color: {ctaButton.backgroundColor};
            --button-fg-color: {ctaButton.foregroundColor};
            --button-border-color: {ctaButton.border.color};
            --button-border-width: {ctaButton.border.width};
            --button-border-radius: {ctaButton.border.radius};
        "
        class:hover:scale-105={!hasTouch}
        class:scale-105={isTouching}
        on:click={handleClickCtaButton}
    >
        {ctaButton.text}
    </button>
    {#if footer != null && footer.length > 0}
        <div class="max-w-[50%] text-center text-sm text-gray-500">
            {@html footer}
        </div>
    {/if}
</section>

<style>
    .title,
    .subtitle {
        color: var(--primary-color);
    }
    .subtitle {
        /* workaround to set a minimum font size */
        font-size: calc(10px + 0.3em);
    }
    button {
        background-color: var(--button-bg-color);
        color: var(--button-fg-color);
        border-style: solid;
        border-color: var(--button-border-color);
        border-width: var(--button-border-width);
        border-radius: var(--button-border-radius);
    }
</style>
